<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import config from "../../../config/config";
import { debounce } from "../../../state/helpers";
// import { param } from "express/lib/request";
/**
 * Add-product component
 */
export default {
  data() {
    return {
      config: config,
      sortBy: "id",
      perPages: 5,
      sortDesc: true,
      page: 1,
      paginations: {},
      limit: 1,
      search: "",
      moment,
      id: "",
      booking: {
        is_cancel: [],
      },
      typeform: {
        selectedCharger: [],
      },
      chargerList: [],
      titleData: {
        id: "",
        name: "",
      },
      searchData: debounce(() => {
        this.getUserReportTitle();
        this.init = false;
      }, 500),
      fields: [
        {
          key: "id",
          sortable: true,
          label: "#",
        },
        {
          key: "name",
          sortable: true,
          label: "Name",
        },
        {
          key: "action",
          sortable: false,
          label: "Action",
        },
      ],
    };
  },
  props: ["userId"],
  components: {},
  validations: {
    titleData: {
      name: { required },
    },
  },
  computed: {
    ...mapGetters("userReport", [
      "getAllReportTitle",
      "loading",
      "reportTitleCount",
      "pagination",
      "getShowReportTitle",
      "getUpdateStatus",
    ]),
  },
  mounted() {
    this.getUserReportTitle();
  },
  methods: {
    ...mapActions("userReport", [
      "getReportTitle",
      "showReportTitle",
      "updateReportTitle",
      "createReportTitle",
      "deleteReportReason",
    ]),
    getUserReportTitle(page = 1) {
      var filters = {
        search: this.search,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
        perPages: this.perPages,
      };
      this.getReportTitle(filters);
    },
    addReportTitle() {
      this.titleData.name = "";
      this.$bvModal.show("bv-modal-add-vehicle-make");
    },
    editReportTitle(title_id) {
      this.resetForm();
      var data = {
        id: title_id,
      };
      this.showReportTitle(data).then(() => {
        this.titleData.id = this.getShowReportTitle.id;
        this.titleData.name = this.getShowReportTitle.name;
        this.$bvModal.show("bv-modal-edit-vehicle-make");
      });
    },
    submitEditForm() {
      this.$v.$touch();
      if (this.$v.titleData.$invalid) {
        return;
      } else {
        const fd = new FormData();
        fd.append("id", this.titleData.id);
        fd.append("name", this.titleData.name);
        this.updateReportTitle(fd).then(() => {
          if (this.getUpdateStatus == 200) {
            this.getUserReportTitle();
          }
          this.$bvModal.hide("bv-modal-edit-vehicle-make");
        });
      }
    },
    submitAddForm() {
      this.$v.$touch();
      if (this.$v.titleData.$invalid) {
        return;
      } else {
        const fd = new FormData();
        fd.append("name", this.titleData.name);
        this.createReportTitle(fd).then(() => {
          if (this.getUpdateStatus == 200) {
            this.getUserReportTitle();
          }
          this.$bvModal.hide("bv-modal-add-vehicle-make");
        });
      }
    },
    deleteReportTitle(make_id) {
      if (confirm("Are You Sure to Delete #" + make_id + " Report Reason")) {
        const fd = new FormData();
        fd.append("id", make_id);
        this.deleteReportReason(fd).then(() => {
          if (this.getUpdateStatus == 200) {
            this.getUserReportTitle();
          }
        });
      }
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getUserReportTitle();
    },
    resetForm() {
      this.$v.$reset();
    },
  },
};
</script>
<template>
  <div class="row">
    <div class="col-12">
      <form action="#" @submit.prevent="typeForm">
        <div class="card details-profile-main">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-md-4">
                <div
                  class="pb-0 page-title-box d-flex align-items-center justify-content-between icon-main-page"
                >
                  <h4 class="card-title page-title-left">
                    Report Reasons ({{ reportTitleCount }})
                  </h4>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row justify-content-end">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <div class="date-range-list">
                        <label>Per Page :</label>
                        <select
                          class="custom-select"
                          v-model="perPages"
                          @change="searchData()"
                        >
                          <option value="5" selected>5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="date-range-list">
                      <label>Search :</label>
                      <div class="text-sm-right">
                        <div class="search-box mr-2 d-inline-block">
                          <div class="position-relative">
                            <input
                              type="text"
                              class="form-control"
                              id="search"
                              @input="searchData()"
                              v-model="search"
                              :placeholder="$t('navbar.search.text')"
                            />
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="d-flex align-items-center">
                  <b-button
                    class="page-title-right btn btn-success btn-rounded mr-2 add-btn"
                    @click="
                      addReportTitle();
                      $bvModal.show('bv-modal-add-vehicle-make');
                    "
                    ><i class="mdi mdi-plus mr-1"></i>
                    Add Report Reason
                  </b-button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-table
                  striped
                  hover
                  :update:sortBy="sortBy"
                  :update:sortDesc="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :items="getAllReportTitle"
                  :fields="fields"
                  :busy="loading"
                  class="table-class"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ $t(" Loading") }}</strong>
                    </div>
                  </template>
                  <template v-slot:cell(action)="items">
                    <b-button
                      @click="editReportTitle(items.item.id)"
                      class="btn btn-success btn-rounded"
                    >
                      <i class="bx bxs-edit"></i>
                    </b-button>
                    &nbsp;
                    <b-button
                      @click="deleteReportTitle(items.item.id)"
                      class="btn btn-danger btn-rounded"
                    >
                      <i class="bx bx-trash"></i>
                    </b-button>
                  </template>
                </b-table>
                <tr v-if="loading == false && getAllReportTitle.length === 0">
                  <td colspan="100%">
                    <h6 align="center">No Report Titles Found</h6>
                  </td>
                </tr>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <pagination
                        :data="pagination"
                        :limit="limit"
                        @pagination-change-page="getUserReportTitle"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- Add vehicle make Model start -->
    <b-modal id="bv-modal-add-vehicle-make" hide-footer @hidden="resetForm">
      <template #modal-title>Add Report Title</template>
      <form action="#" @submit.prevent="submitAddForm">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Title</label>
              <input
                id="name"
                type="text"
                class="form-control"
                placeholder="Enter Title"
                v-model="$v.titleData.name.$model"
                :class="{ 'is-invalid': $v.titleData.name.$error }"
                name="name"
              />
              <div v-if="$v.titleData.name.$error" class="invalid-feedback">
                <span v-if="!$v.titleData.name.required">Please enter title</span>
              </div>
            </div>
          </div>
        </div>
        <div class="text-end mt-3">
          <button
            type="button"
            @click="
              resetForm();
              $bvModal.hide('bv-modal-add-vehicle-make');
            "
            class="btn btn-light"
          >
            Close</button
          >&nbsp;
          <button type="submit" class="btn ms-1 btn-success">Submit</button>
        </div>
      </form>
    </b-modal>
    <!-- Add vehicle make Model end -->
    <!-- Edit vehicle make Model start -->
    <b-modal id="bv-modal-edit-vehicle-make" hide-footer @hidden="resetForm">
      <template #modal-title>Edit Report Title</template>
      <form action="#" @submit.prevent="submitEditForm">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group mb-3">
              <label>Title</label>
              <input
                id="name"
                type="text"
                class="form-control"
                placeholder="Enter Title"
                v-model="$v.titleData.name.$model"
                :class="{ 'is-invalid': $v.titleData.name.$error }"
                name="name"
              />
              <div v-if="$v.titleData.name.$error" class="invalid-feedback">
                <span v-if="!$v.titleData.name.required">Please enter title</span>
              </div>
            </div>
          </div>
        </div>
        <div class="text-end mt-3">
          <button
            type="button"
            @click="
              resetForm();
              $bvModal.hide('bv-modal-edit-vehicle-make');
            "
            class="btn btn-light"
          >
            Close</button
          >&nbsp;
          <button type="submit" class="btn ms-1 btn-success">Submit</button>
        </div>
      </form>
    </b-modal>
    <!-- Edit vehicle make Model end -->
  </div>
</template>
<style>
.multiselect {
  width: 250px !important;
}
</style>
